export default function userHasPermission(claims = [], requiredClaim) {
    if (Array.isArray(requiredClaim)) {
        return claims.filter(claimName => requiredClaim.includes(claimName)).length === requiredClaim.length;
    } else {
        return !!claims.filter(claimName => claimName === requiredClaim).length > 0;
    }

}